// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberUpsearchModel {
    static getAttributeTypeMap() {
        return PrescriberUpsearchModel.attributeTypeMap;
    }
}
PrescriberUpsearchModel.discriminator = undefined;
PrescriberUpsearchModel.attributeTypeMap = [
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "prescriberLicenses",
        "baseName": "prescriberLicenses",
        "type": "Array<PrescriberLicenseUpsearchModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<PrescriberSharedExternalIdUpsearchModel>"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PrescriberSharedAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PrescriberSharedPhoneUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PrescriberSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "nickname",
        "baseName": "nickname",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    }
];
//# sourceMappingURL=prescriberUpsearchModel.js.map